// ===============================================
// 余白に関するクラス定義
// ===============================================

/** Margin TOP: Default */
export const spaceTopDefault = 'pt-6 m-pt-5 s-pt-3'
